import { render, staticRenderFns } from "./learningMaterialsUSA.vue?vue&type=template&id=924834e8&scoped=true"
import script from "./learningMaterialsUSA.vue?vue&type=script&lang=js"
export * from "./learningMaterialsUSA.vue?vue&type=script&lang=js"
import style0 from "./learningMaterialsUSA.vue?vue&type=style&index=0&id=924834e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "924834e8",
  null
  
)

export default component.exports